import personalDetailsJson from '../../../assets/translations/personal-details.json'

export const personalDetailsContent: any = personalDetailsJson
